import accountNavigation from "@navigations/account"
import mainNavigation from "@navigations/main"
import publicNavigation from "@navigations/public"
import type { RouteObject } from "react-router-dom"
import { createBrowserRouter } from "react-router-dom"

const router: RouteObject[] = []

router.push(
  ...mainNavigation,
  ...publicNavigation,
  ...accountNavigation
  //...customerNavigation
)

export default createBrowserRouter(router)
